import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { supplyOrdersTypes } from 'actions/types'

const initialState = []
const baseType = supplyOrdersTypes.FETCH_SUPPLY_ORDERS

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
